<template>
	<div class="main" v-loading.fullscreen="isLoad" element-loading-background="rgba(0, 0, 0,0)">
		<el-breadcrumb separator-class="el-icon-arrow-right">
			<el-breadcrumb-item>商品管理</el-breadcrumb-item>
			<el-breadcrumb-item>商品分类</el-breadcrumb-item>
		</el-breadcrumb>

		<el-form :inline="true" :model="item" class="search">
			<el-form-item label="分类名称">
				<el-input v-model="item.name" placeholder="请输入分类名称" size="small" @keyup.native.enter=""></el-input>
			</el-form-item>
			<el-form-item>
				<el-button type="primary" @click="submit" size="medium">查询</el-button>
			</el-form-item>
		</el-form>
		<div class="btns">
			<el-button type="primary" size="small" @click="add" v-auth="['store/productCategory/add']">添加分类</el-button>
            <el-button size="mini" type="primary" @click="recommend()">推荐至首页</el-button>
			<!-- <el-button type="danger" size="small" @click="delAll">批量删除</el-button> -->
		</div>

		<el-table ref="table" :data="list" border stripe highlight-current-row
		@selection-change="handleSelectionChange" row-key="id" lazy
			:load="load" :tree-props="{children: 'children', hasChildren: 'childCount'}">
			<el-table-column type="selection" align="center"></el-table-column>
			<el-table-column width="60" align="center">
			</el-table-column>
			<el-table-column prop="name" label="分类名称"></el-table-column>
			<el-table-column label="上级分类">
				<template slot-scope="scope">
					<div style="display: flex; align-items: center;" v-if="scope.row.parent">
						{{scope.row.parent.name}}
					</div>
				</template>
			</el-table-column>
			<el-table-column label="分类图标">
				<template slot-scope="scope">
					<div style="display: flex; align-items: center;">
						<img :src="scope.row.logo" height="30" style="display: flex; margin-right: 5px;" />
					</div>
				</template>
			</el-table-column>
			<el-table-column prop="orders" label="排序号" align="center" width="100"></el-table-column>
			<el-table-column  label="所属行业" align="center">
				<template slot-scope="scope">
					<div style="display: flex; align-items: center;justify-content: center" v-if="scope.row.industry">
						{{scope.row.industry.name}}
					</div>
				</template>
			</el-table-column>
			<el-table-column prop="last_modified_date" label="更新时间" align="center"></el-table-column>
			<el-table-column label="操作" width="160" align="center">
				<template slot-scope="scope">
					<el-button size="mini" type="primary" @click="edit(scope.row.id)" v-auth="['store/productCategory/edit']">编辑</el-button>
					<el-popconfirm title="您确定要删除这条数据吗？" @confirm="del(scope.row)" class="l10" v-auth="['store/productCategory/delete']">
						<el-button size="mini" type="danger" slot="reference">删除</el-button>
					</el-popconfirm>
				</template>
			</el-table-column>
		</el-table>
	</div>
</template>
<script>
	export default {
		name: 'index',
		data() {
			return {
				list: [],
				isLoad: false,
				pageSize: 20,
				total: 0,
				page: 1,
				// 查询
				item: {}
			}
		},
		created() {
			this.loadList()
		},
		methods: {
			loadList() {
				if (this.isLoad)
					return
				this.isLoad = !this.isLoad
				// 树形数据 有children来标识
				this.axios.post('/store/productCategory/listTreeByPid', {
					name: this.item.name,
				}).then(res => {
					this.isLoad = !this.isLoad
					this.list = res.data.list.data
				}).catch(() => {
					this.isLoad = !this.isLoad
				})
			},
			load(tree, treeNode, resolve) {
				//1415567502557691905
				this.loadItem = []
				this.axios.post('/store/productCategory/listTreeByPid', {
					parentId: tree.id
				}).then(res => {
					this.list1 = res.data
					this.loadItem = this.list1
					resolve(this.loadItem)
				}).catch(() => {
					this.isLoad = !this.isLoad
				})
			},
			// 跳转到edit添加
			add() {
				this.$router.push({
					path: '/Category/edit.html'
				});
			},
			// 传一个ID跳转到edit页面，进行编辑
			edit(id) {
				console.log(id)
				this.$router.push({
					path: '/Category/edit.html',
					query: {
						id: id
					}
				});
			},

			//
			del(scope) {
				let id = scope.id
				if (this.isLoad) {
					return
				}
				let ids = [id]
				this.isLoad = !this.isLoad
				this.axios.delete('/store/productCategory/delete', {
				data: {
					ids: ids
				}
				})
				.then(() => {
					this.isLoad = !this.isLoad
					this.$message.success({
						message: '删除成功',
						showClose: false
					});
					this.loadList()
				})
				.catch(() => {
					this.isLoad = !this.isLoad
				})
			},
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},
			recommend: function () {
				let id = []
				let parentIds = []
				let arrRefs = this.$refs.table.store.states.lazyTreeNodeMap
				for (let key in this.multipleSelection) {
					let item = this.multipleSelection[key]
					parentIds.push(item.parentId)
					id.push(item.id)
				}

				if (this.isLoad)
					return
				this.isLoad = !this.isLoad
				//  删除接口中的值
				this.axios.delete('/store/productCategory/recommend', {
					data: {
						ids: id
					}
				}).then(() => {
					this.isLoad = !this.isLoad
					this.$message.success({
						message: '设置成功',
						showClose: false
					});
					this.loadList()
				}).catch(() => {
					this.isLoad = !this.isLoad
				})
			},
			delAll() {
				let id = []
				let parentIds = []
				let arrRefs = this.$refs.table.store.states.lazyTreeNodeMap
				for (let key in this.multipleSelection) {
					let item = this.multipleSelection[key]
					parentIds.push(item.parentId)
					id.push(item.id)
				}

				// let arrRefs = this.$refs.table.store.states.lazyTreeNodeMap
				// let arrParent = arrRefs[parentIds]
				if (this.isLoad)
					return
				this.isLoad = !this.isLoad
				//  删除接口中的值
				this.axios.delete('/store/productCategory/delete', {
					data: {
						ids: id
					}
				}).then(() => {
					this.isLoad = !this.isLoad
					this.$message.success({
						message: '删除成功',
						showClose: false
					});
					this.loadList()
				}).catch(() => {
					this.isLoad = !this.isLoad
				})
			},
			// 搜索查询
			submit() {
				this.item.page = 1
				this.loadList()
			},
			// 导出
			excelOut() {
				return;
				if (this.isLoad)
					return
				this.isLoad = !this.isLoad
				this.axios.get('', {
						params: {
							nickname: this.item.nickname,
							title: this.item.title
						}
					})
					.then(res => {
						this.isLoad = !this.isLoad
						// 导出
						window.open(res.url)
					})
					.catch(() => {
						this.isLoad = !this.isLoad
					})
			}
		}
	}
</script>
<style scoped>
</style>
